import { render, staticRenderFns } from "./AthleteCertificationList.vue?vue&type=template&id=7bbdda56&scoped=true&"
import script from "./AthleteCertificationList.vue?vue&type=script&lang=js&"
export * from "./AthleteCertificationList.vue?vue&type=script&lang=js&"
import style0 from "./AthleteCertificationList.vue?vue&type=style&index=0&id=7bbdda56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbdda56",
  null
  
)

export default component.exports